import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { colorPalettes, applyColorPalette } from './theme/colorPalettes';
import ThemeSelector from './components/ThemeSelector';
import Dashboard from './pages/Dashboard';
import SpotManagement from './pages/SpotManagement';
import Login from './pages/Login';
import MobileApp from './pages/MobileApp';

function App() {
  const [currentTheme, setCurrentTheme] = useState('default');
  const [isAuthenticated, setIsAuthenticated] = useState(true); // 프로토타입에서는 항상 인증됨
  const [showThemeSelector, setShowThemeSelector] = useState(false);

  // 초기 테마 적용
  useEffect(() => {
    const savedTheme = localStorage.getItem('selectedTheme') || 'default';
    const theme = colorPalettes[savedTheme] || colorPalettes.default;
    applyColorPalette(theme);
    setCurrentTheme(savedTheme);
  }, []);

  // ALT+T 키보드 단축키 핸들러
  useEffect(() => {
    const handleKeyDown = (e) => {
      // ALT+T 키 조합 감지
      if (e.altKey && e.key.toLowerCase() === 't') {
        e.preventDefault();
        setShowThemeSelector((prev) => !prev);
      }
      // ESC 키로 닫기
      if (e.key === 'Escape' && showThemeSelector) {
        setShowThemeSelector(false);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [showThemeSelector]);

  const handleThemeChange = (themeKey) => {
    setCurrentTheme(themeKey);
    localStorage.setItem('selectedTheme', themeKey);
  };

  return (
    <div className="min-h-screen" style={{ backgroundColor: 'var(--color-background)' }}>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/mobile" element={<MobileApp />} />
          <Route
            path="/*"
            element={
              isAuthenticated ? (
                <>
                  {showThemeSelector && (
                    <div className="fixed top-4 right-4 z-50">
                      <ThemeSelector
                        currentTheme={currentTheme}
                        onThemeChange={handleThemeChange}
                        onClose={() => setShowThemeSelector(false)}
                      />
                    </div>
                  )}
                  <Routes>
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/spots" element={<SpotManagement />} />
                    <Route path="/" element={<Navigate to="/dashboard" replace />} />
                  </Routes>
                </>
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
